import { LocationChecklistFlag } from './types';

export const mapChecklistLocations = (
  user,
  locations,
  checkedIds = []
): LocationChecklistFlag[] => {
  const {
    managersCanSeeSchedulesInOtherLocations,
    usersCanSeeSchedulesInOtherLocations,
    usersCanSeeOtherSchedules,
  } = user.orgSettings;

  const canSeeOtherSchedules = user.isManager || usersCanSeeOtherSchedules;
  const canSeeSchedulesInOtherLocations =
    user.isAdmin ||
    (user.isManager && managersCanSeeSchedulesInOtherLocations) ||
    (!user.isManager && usersCanSeeSchedulesInOtherLocations && usersCanSeeOtherSchedules);

  let targetLocations = [];
  if (canSeeSchedulesInOtherLocations) {
    targetLocations = locations;
  } else if (canSeeOtherSchedules) {
    targetLocations = user.locations;
  }

  return targetLocations.map((location) => ({
    id: location.id,
    name: location.name,
    checked: checkedIds.length ? checkedIds.includes(location.id) : true,
  }));
};
